import Product from '@grafikr/shopify-typescript/type/Product';
import { component } from 'picoapp';
import { scrollLock, attributeToggle } from 'utils/node';
import { getCart } from 'utils/cart';
import Modal from 'utils/modal';
import LinkedProducts from 'framework/linked-products';

export default component(async (node, ctx) => {
  const data = JSON.parse(document.querySelector('[data-json]').textContent) as Product;
  const form = document.querySelector<HTMLFormElement>('[data-product-form]');
  const quickbuyForm = node.querySelector('[data-form]');
  const modal = Modal(node, node.parentElement, 'lg:opacity-0');

  const loading: HTMLElement = document.querySelector('[data-loading-state]');
  const toggle: HTMLButtonElement = document.querySelector(`[data-toggle="${node.id}"]`);
  const toggleTexts = toggle.querySelectorAll<HTMLSpanElement>('[data-toggle-text]');

  const content: HTMLElement = document.querySelector('[data-content]');

  const updateTriggerText = (response) => {
    const colors = response[1];

    if (!colors || !colors.length) return;

    const hasSwatches = colors.filter((item) => item.handle !== data.handle).length;

    if (!hasSwatches) {
      const relatedToggleText = [...toggleTexts].find((item) => item.dataset.toggleText === 'quantity');

      if (relatedToggleText) {
        toggleTexts.forEach((item) => {
          item.hidden = true
        });

        relatedToggleText.hidden = false;
      }
    }
  }

  const init = async () => {
    const linkedProducts = LinkedProducts(node, {
      classes: {
        isActive: 'is-active',
        countItem: 'product__count',
        swatchItem: 'product__swatch',
      },
      elements: {
        swatches: '[data-swatches]',
        products: '[data-products]',
      }
    });

    const response = await Promise.all([
      linkedProducts.getRelatedProducts(),
      linkedProducts.getRelatedColors(),
    ]);

    const relatedItems = response.flat().filter((item) => item.handle !== data.handle);

    loading.hidden = true;

    if (!relatedItems.length) {
      form.hidden = false;
      toggle.hidden = true;
    } else {
      toggle.hidden = false;
      form.hidden = true;

      updateTriggerText(response);

      await Promise.all([
        linkedProducts.renderProducts(),
        linkedProducts.renderSwatches(),
      ]);
    }
  }

  init();

  const handleSubmit = async (event: SubmitEvent) => {
    event.preventDefault();

    const submit = quickbuyForm.querySelector('button[type="submit"]');
    submit.textContent = window.theme.strings.states.adding;

    const response = await fetch(`${form.action}.js`, {
      method: form.method,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new FormData(form),
    });

    const product = await response.json();

    document.dispatchEvent(new CustomEvent('cart:added', {
      detail: {
        product,
      },
    }));

    submit.textContent = window.theme.strings.addToCart;
    modal.close();

    const cartData = await getCart();
    ctx.emit('cart:update', { cart: cartData });
  };

  if (quickbuyForm) {
    quickbuyForm.addEventListener('submit', handleSubmit);
  }

  const toggleContent = () => {
    content.classList.toggle('lg:hidden');
    attributeToggle(content);
  };

  if (toggle) {
    toggle.addEventListener('click', () => {
      toggleContent();
      modal.open();
    });
  }

  modal.on('open', () => scrollLock());
  modal.on('close', () => {
    toggleContent();
    scrollLock(false);
  });
});
